/**
 * Parse date strings as local calendar dates (avoids YYYY-MM-DD UTC off-by-one).
 */
export function parseLocalDate(value) {
  if (value == null || value === '') return null;
  const raw = String(value).trim();
  const iso = raw.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (iso) {
    return new Date(
      Number.parseInt(iso[1], 10),
      Number.parseInt(iso[2], 10) - 1,
      Number.parseInt(iso[3], 10)
    );
  }
  const d = new Date(raw);
  return Number.isNaN(d.getTime()) ? null : d;
}

export function getTodayYmdLocal() {
  const d = new Date();
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

export function formatLocalDateTime(value) {
  const date = parseLocalDate(value);
  if (!date) return 'N/A';
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const year = date.getFullYear();
  const hours = date.getHours();
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const ampm = hours >= 12 ? 'PM' : 'AM';
  const displayHours = hours % 12 || 12;
  return `${month}-${day}-${year}/${String(displayHours).padStart(2, '0')}:${minutes} ${ampm}`;
}

export function formatLocalDateShort(value) {
  const date = parseLocalDate(value);
  if (!date) return 'N/A';
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const year = date.getFullYear();
  return `${month}-${day}-${year}`;
}
